import io from 'socket.io-client'
import store from '../redux-store'
import UserActions from '../actions/user/user-actions'
import GameActions from '../actions/game/game-actions';

// Example conf. You can move this to your config file.
// const host = 'http://localhost:3000';
// const socketPath = '/api/socket.io';

export default class SocketClient {
  socket;

  allowedActions = {
    'getGameById': (payload) => UserActions.getGameById(payload.gameId),
    'update_game': (payload) => GameActions.updateGame(payload),
    'player_moved': (payload) => GameActions.playerMoved(payload),
    'game_over': (payload) => GameActions.setFinal(payload),
  }

  connect() {
    //console.log('--- connecting sockets ---')
    /*
    if (!!this.socket) {
      console.log('- already have a socket -')
      Promise.resolve();
    }
    */
    this.socket = io.connect('/');
    //this.socket = io('/');

    
    this.socket.on('clientAction', result => {
      //console.log('- on clientAction -')
      //console.log(result)
      if (this.allowedActions[result.action]) {
        store.dispatch(this.allowedActions[result.action](result.payload))
      }
    })
    
/*
    this.socket.onAny((eventName, ...args) => {
      console.log({eventName, args})
    })
*/
    return new Promise((resolve, reject) => {
      this.socket.on('connect', () => {
        console.log('On socket connect x2')
        resolve()
      });
      this.socket.on('connect_error', (error) => {
        console.log(error)
        // this.socket = null;
        return reject(error)
      });

    });
  }

  disconnect() {
    return new Promise((resolve) => {
      this.socket.disconnect(() => {
        this.socket = null;
        resolve();
      });
    });
  }

  emit(event, data) {
    return new Promise((resolve, reject) => {
      if (!this.socket) return reject('No socket connection.');

      return this.socket.emit(event, data, (response) => {
        // Response is the optional callback that you can use with socket.io in every request. See 1 above.
        if (response.error) {
          console.error(response.error);
          return reject(response.error);
        }

        return resolve();
      });
    });
  }

  on(event, fun) {
    // No promise is needed here, but we're expecting one in the middleware.
    return new Promise((resolve, reject) => {
      if (!this.socket) return reject('No socket connection.');
      console.log({event, fun})
      this.socket.on(event, fun);
      resolve();
    });
  }

}
